type Listener = (pending: number) => void;

let pending = 0;
const listeners = new Set<Listener>();

const emit = () => {
  listeners.forEach((l) => l(pending));
};

export const loadingBus = {
  start() {
    pending += 1;
    emit();
  },
  stop() {
    pending = Math.max(0, pending - 1);
    emit();
  },
  reset() {
    pending = 0;
    emit();
  },
  subscribe(listener: Listener) {
    listeners.add(listener);
    listener(pending);
    return () => {
      listeners.delete(listener);
    };
  },
  getPending() {
    return pending;
  },
};
